export default __webpack_public_path__ + "static/media/tagIcon-01.cb734666.svg";